import { useAgentEditorStore } from '@/state/root';
import { runInAction } from 'mobx';

export function useClearEditor() {
    const agentEditorStore = useAgentEditorStore();

    return {
        clearEditor: async () => {
            runInAction(() => {
                agentEditorStore.resetInputAgent();
                agentEditorStore.resetTtsSelectedVoice();
                agentEditorStore.resetTtsSelectedLanguage();
                agentEditorStore.resetCurrentTab();
                agentEditorStore.resetSelectedPresenter();
                agentEditorStore.resetPresenterIsStitch();
                agentEditorStore.resetErrorTabs();
                agentEditorStore.resetErrors();
                agentEditorStore.resetUploadingDocumentFiles();
                agentEditorStore.resetDeletedDocumentFiles();
                agentEditorStore.resetStarterQuestions();
                agentEditorStore.resetGreetings();
                agentEditorStore.resetIsEditorLoading();
                agentEditorStore.resetIsEditingDraftAgent();
                agentEditorStore.resetPresenterBackgroundSourceUrl();
                agentEditorStore.resetPresenterBackgroundColor();
                agentEditorStore.resetPresenterBackgroundThumbnailUrl();
                agentEditorStore.resetInitAgentState();
                agentEditorStore.resetIsPlaygroundLoaded();
                agentEditorStore.resetLLM();
                agentEditorStore.resetUi();
                agentEditorStore.resetBaseKnowledge();
                agentEditorStore.resetTriggers();
            });
        },
    };
}
